import vuexStore from './vuex';
import router from './router';
import { initGlobalState } from 'qiankun';

const { getters } = vuexStore;

// 暂停路由跳转函数
export const pauseRouter = callback => {
    let resolve, reject;
    const promise = new Promise((_resolve, _reject) => {
        resolve = _resolve;
        reject = _reject;
    });
    const pause = {
        promise,
        resolve,
        reject,
        callback
    };
    vuexStore.dispatch('set_AllowRouterJump', pause);
};

// 恢复路由跳转函数
export const resumeRouter = () => {
    vuexStore.dispatch('set_AllowRouterJump', {
        promise: Promise.resolve(),
        resolve: null,
        reject: null,
        callback: null
    });
};

const actions = initGlobalState(getters.initChildAppState);

actions.onGlobalStateChange(newState => {
    const { loginStatus = '' } = newState;
    if (loginStatus === 'off') {
        const redirectUrl = vuexStore.getters.userInfo.dccTenantAjmdLogoutUrl;
        if (redirectUrl) {
            window.location.href = redirectUrl;
        } else {
            router.replace({
                path: '/login'
            });
        }
        return;
    }
});

actions.getGlobalState = key => {
    // 下发给子应用，用户获取下发到子应用的前置状态
    return key ? getters.initChildAppState[key] : getters.initChildAppState;
};

export default actions;
